import React from "react";
import * as formik from "components/generic/form/formik";
import { LeaveFeedback } from "components/common/feedback";
import { Overlay } from "components/common/candidate";

export default props => (
  <Overlay>
    <LeaveFeedback
      {...props}
      footer={
        <formik.Checkbox
          name="shared"
          title="I'm comfortable with The Lobby sharing this review on the insider's profile."
        />
      }
    />
  </Overlay>
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Feedback/View.js